<template>
  <div>
    <top></top>
    <el-row>
      <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
      <el-col :xs="22" :sm="18" :md="16" :lg="14" :xl="12">
        <div class="container">
          <dataLabel :newgetList="lableGetList"></dataLabel>
          <div class="conList">
            <p v-if="langSet == 'zh'">
              展商列表 当前展商数量为{{
              companyList.length
              }}条,最多只能筛选20条进行提交
              <br />
            </p>
            <p v-if="langSet == 'en'">
              {{ companyList.length }} exhibitors found (Kindly note that a
              maximum of 20 exhibitors could be selected)
              <br />
            </p>
          </div>
          <div class="conList">
            <p v-if="langSet == 'zh'">点击公司商标浏览档案</p>
            <p v-if="langSet == 'en'">Click on the company logos to browse their profile</p>
          </div>
          <div class="companyWrap" v-if="companyList.length > 0">
            <div :class="item.is_ad=='1'?'isad':''" v-for="(item,index) in companyList" :key="item.id" @click="togglePay(item,index)">
              <div class="ad" v-if="item.is_ad=='1'">{{langSet=='zh'?'推荐':'Recommend'}}</div>
              <img
                v-if="item.logo.length > 0"
                class="logo"
                :src="$imgUrl + item.logo"
                alt
                @click.stop="toDetail(item.id)"
              />
              <img
                v-else
                class="logo"
                src="../../assets/logo.jpg"
                alt
                @click.stop="toDetail(item.id)"
              />
              <div class="middle">
                <p
                  v-if="langSet == 'zh' || item.enCompanyName.length == 0"
                  class="title"
                >{{ item.companyName }}</p>
                <p
                  v-if="langSet == 'en' && item.enCompanyName.length > 0"
                  class="title"
                >{{ item.enCompanyName }}</p>
                <p class="fonts">
                  <span v-if="langSet == 'zh' || item.en_country.length == 0">
                    {{
                    item.country
                    }}
                  </span>
                  <span v-if="langSet == 'en' && item.en_country.length > 0">
                    {{
                    item.en_country
                    }}
                  </span>
                  <span
                    v-if="
                      item.province.length > 0 || item.en_country.length > 0
                    "
                  >-</span>
                  <span v-if="langSet == 'zh' || item.en_province.length == 0">{{ item.province }}</span>
                  <span v-if="langSet == 'en' && item.en_province.length > 0">
                    {{
                    item.en_province
                    }}
                  </span>
                </p>
                <p
                  v-if="
                    langSet == 'zh' ||
                    (item.en_exhibitionArea
                      ? item.en_exhibitionArea.length == 0
                      : '')
                  "
                  class="sub fonts"
                >
                  <span>{{ item.exhibitionArea }}</span>
                  <span v-if="item.hallNo.length != 0 || item.boothNo.length > 0">/</span>
                  <span>{{ item.hallNo }}</span>
                  <span>{{ item.boothNo }}</span>
                </p>
                <p
                  v-if="
                    langSet == 'en' &&
                    (item.en_exhibitionArea
                      ? item.en_exhibitionArea.length > 0
                      : '')
                  "
                  class="sub fonts"
                >
                  <span>{{ item.en_exhibitionArea }}</span>
                  <span v-if="item.hallNo.length != 0 || item.boothNo.length > 0">/</span>
                  <span>{{ item.en_hallNo?item.en_hallNo:item.hallNo }}</span>
                  <span>{{ item.boothNo }}</span>
                </p>
              </div>
              <!-- <div class="right">
                <el-checkbox @change="togglePay(item,index)"></el-checkbox>
                <div v-if="item.active">
                  <img
                  class="duihao-icon"
                  src="../../assets/duihao.png"
                  alt
                />
                </div>
              </div>-->
              <!-- <img
                  class="collect-icon"
                  v-if="item.isCollect == 0"
                  @click.stop="collectBtn(item.id, 1, index)"
                  src="../../assets/collect.png"
                  alt
                />
                <img
                  class="collect-icon"／
                  v-if="item.isCollect == 1"
                  @click.stop="collectBtn(item.id, 0, index)"
                  src="../../assets/collect_en.png"
                  alt
              />-->
              <!-- </div> -->
            </div>
            <!-- <div class="lookmore" @click="more()">查看更多</div> -->
          </div>
          <demandBox :subData="SubData"></demandBox>
          <div class="gouwuche" @click="openList">
            <img src="../../assets/biaolist.png" alt />
            <div class="gouwuche_num" v-if="this.pcNewlist.length>0">{{this.pcNewlist.length}}</div>
          </div>
          <div class="zhezhao" v-if="openListSwitch" @click="openList">
            <div class="Listdialog" @click.stop="dialogstop">
              <div class="companyWrap" v-if="pcNewlist.length > 0">
                <div v-for="(item,index) in pcNewlist" :key="item.id">
                  <img
                    v-if="item.logo.length > 0"
                    class="logo"
                    :src="$imgUrl + item.logo"
                    alt
                    @click.stop="toDetail(item.id)"
                  />
                  <img v-else class="logo" src="../../assets/logo.jpg" alt />
                  <div class="middle">
                    <p
                      v-if="langSet == 'zh' || item.enCompanyName.length == 0"
                      class="title"
                    >{{ item.companyName }}</p>
                    <p
                      v-if="langSet == 'en' && item.enCompanyName.length > 0"
                      class="title"
                    >{{ item.enCompanyName }}</p>
                    <p class="fonts">
                      <span v-if="langSet == 'zh' || item.en_country.length == 0">
                        {{
                        item.country
                        }}
                      </span>
                      <span v-if="langSet == 'en' && item.en_country.length > 0">
                        {{
                        item.en_country
                        }}
                      </span>
                      <span
                        v-if="
                      item.province.length > 0 || item.en_country.length > 0
                    "
                      >-</span>
                      <span
                        v-if="langSet == 'zh' || item.en_province.length == 0"
                      >{{ item.province }}</span>
                      <span v-if="langSet == 'en' && item.en_province.length > 0">
                        {{
                        item.en_province
                        }}
                      </span>
                    </p>
                    <p
                      v-if="
                    langSet == 'zh' ||
                    (item.en_exhibitionArea
                      ? item.en_exhibitionArea.length == 0
                      : '')
                  "
                      class="sub fonts"
                    >
                      <span>{{ item.exhibitionArea }}</span>
                      <span v-if="item.hallNo.length != 0 || item.boothNo.length > 0">/</span>
                      <span>{{ item.hallNo }}</span>
                      <span>{{ item.boothNo }}</span>
                    </p>
                    <p
                      v-if="
                    langSet == 'en' &&
                    (item.en_exhibitionArea
                      ? item.en_exhibitionArea.length > 0
                      : '')
                  "
                      class="sub fonts"
                    >
                      <span>{{ item.en_exhibitionArea }}</span>
                      <span v-if="item.hallNo.length != 0 || item.boothNo.length > 0">/</span>
                      <span>{{ item.en_hallNo }}</span>
                      <span>{{ item.boothNo }}</span>
                    </p>
                  </div>
                  <div class="del-right">
                    <!-- <el-checkbox @change="togglePay(item,index)"></el-checkbox> -->
                    <img
                      class="del-icon"
                      @click.stop="delgouList(index)"
                      src="../../assets/del.png"
                      alt
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <bottom></bottom>
  </div>
</template>

<script>
import Vue from "vue";
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import dataLabel from "./components/label.vue";
import demandBox from "./components/demandBox.vue";
import {
  getCompanyList,
  getCollect,
  sendEmial,
  getUser,
  getNewCompanyList,
} from "@/api/api";
export default {
  props: {},
  components: {
    top,
    bottom,
    dataLabel,
    demandBox,
  },
  data() {
    return {
      newdata: "",
      total: 0,
      companyList: [],
      langSet: "",
      page: 1,
      pagesize: 9999,
      productClass_1: "",
      productClass_2: "",
      country: "",
      memberid: "",
      productClass_2Name: [],
      productClass_2EnName:[],
      selectedList: [],
      isactive: 0,
      pcNewlist: [],
      openListSwitch: false,
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "zh";
    this.memberid = localStorage.getItem("memberid");
    // this.open();
    // let data = this.$qs.stringify({
    //   keywords: this.keywords,
    //   showareaid: this.showareaid,
    //   memberid: this.memberid,
    //   productClass_1: this.productClass_1,
    //   productClass_2: this.productClass_2,
    //   country: this.country,
    //   pagesize: this.pagesize,
    //   page: this.page,
    // });
    // this.getList(data);
  },
  methods: {
    dialogstop(){

    },
    openList() {
      if(!this.openListSwitch&&this.pcNewlist.length==0){
        return
      }
      this.openListSwitch = !this.openListSwitch;
    },
    open() {
      this.$alert(
        "Please click “Submit” after selecting your desired exhibitors. You may need to “Submit” again if you choose other exhibitors from different product groups.",
        "Important notice",
        {
          confirmButtonText: "ok",
          callback: (action) => {},
        }
      );
    },
    delgouList(index) {
      var pcNewlist = this.pcNewlist;
      pcNewlist.splice(index, 1);
    },
    togglePay: function (item, index) {
      console.log(item, index);
      var pcNewlist = this.pcNewlist;
      var newArr = [];
      var screenList = [];
      if(item.en_productClassName==null){
        item.en_productClassName=this.productClass_2EnName
      }
      pcNewlist.push(item);
      this.pcNewlist = pcNewlist;
      if (this.langSet == "zh") {
        // this.$message("所選的參展商已成功添加到您的名单");
        this.$message({
          message:"所選的參展商已成功添加到您的名单",
          offset:600,
          customClass:'mesgStyle',
          iconClass:'w',
          center:true
          })
      } else {
        this.$message({
          message:"Selected exhibitor successfully added to your list",
          offset:600,
          customClass:'mesgStyle',
          iconClass:'w',
          center:true
          })
      }
      // if (item.active) {
      //   Vue.set(item, "active", false); //为item添加不存在的属性，需要使用vue提供的Vue.set( object, key, value )方法。
      //   this.companyList.map((item) => {
      //     if (item.active) {
      //       newArr.push(item);
      //     }
      //   });
      //   newArr.map((items) => {
      //     var obj = {
      //       title: items.companyName,
      //       telephoneNumber: items.telephoneNumber,
      //       email: items.email,
      //       en_title: items.enCompanyName,
      //       country: items.en_country,
      //       province: items.en_province,
      //     };
      //     screenList.push(obj);
      //   });

      //   this.pcNewlist = screenList;
      //   console.log(this.pcNewlist);
      // } else {
      //   Vue.set(item, "active", true);
      //   this.companyList.map((item) => {
      //     if (item.active) {
      //       newArr.push(item);
      //     }
      //   });
      //   newArr.map((items) => {
      //     var obj = {
      //       title: items.companyName,
      //       telephoneNumber: items.telephoneNumber,
      //       email: items.email,
      //       en_title: items.enCompanyName,
      //       country: items.en_country,
      //       province: items.en_province,
      //     };
      //     screenList.push(obj);
      //   });

      //   this.pcNewlist = screenList;
      //   console.log(this.pcNewlist);
      //   var msgtext = "";
      //   if (this.pcNewlist.length > 30) {
      //     if (this.langSet == "zh") {
      //       msgtext =
      //         "当前展商数量为" +
      //         this.pcNewlist.length +
      //         "条," +
      //         "最多只能筛选30条";
      //     } else {
      //       msgtext = msgtext =
      //         this.pcNewlist.length +
      //         " exhibitor be selected, please select less then 30 exhibitors";
      //       // "当前展商数量为" +
      //       // this.pcNewlist.length +
      //       // "条," +
      //       // "最多只能筛选30条";
      //     }
      //     this.$message(msgtext);
      //     return;
      //   } else if (this.pcNewlist.length == 0) {
      //     if (this.langSet == "zh") {
      //       msgtext =
      //         "当前展商数量为" +
      //         this.pcNewlist.length +
      //         "条," +
      //         "最少需要筛选1条";
      //     } else {
      //       msgtext =
      //         this.pcNewlist.length +
      //         " exhibitor be selected, please select 1 exhibitor at least";
      //       // "当前展商数量为" +
      //       // this.pcNewlist.length +
      //       // "条," +
      //       // "最少需要筛选1条";
      //     }
      //     this.$message(msgtext);
      //     return;
      //   }
      // }
    },

    SubData(textarea) {
      console.log(this.pcNewlist);
      var SubpcNewlist=[];
      this.pcNewlist.map((item)=>{
        var syn='';
        if(item.en_productClassName){
          item.en_productClassName.map((items)=>{
            syn=syn+items+'; '
          })
        }
        var obj = {
          title: item.companyName,
          telephoneNumber: item.telephoneNumber,
          email: item.email,
          en_title: item.enCompanyName,
          country: item.en_country,
          province: item.en_province,
          officialWebsite:item.officialWebsite,
          boothNo:item.boothNo,
          introduction:syn
        };
        SubpcNewlist.push(obj)
      })
      let data = this.$qs.stringify({
        memberid: this.memberid,
        uuid: this.$uuid,
      });
      getUser(data)
        .then((res) => {
          if (res.data.errno == 0) {
            var userInfo = res.data.rst;
            console.log(userInfo);
            // var companyList = this.companyList;
            // var newlist = [];
            // companyList.map((item) => {
            //   var obj = {
            //     title: item.companyName,
            //     telephoneNumber: item.telephoneNumber,
            //     email: item.email,
            //   };
            //   newlist.push(obj);
            // });
            var msgtext = "";

            if (this.pcNewlist.length > 20) {
              if (this.langSet == "zh") {
                msgtext =
                  "当前展商数量为" +
                  this.pcNewlist.length +
                  "条," +
                  "最多只能筛选20条";
              } else {
                msgtext =
                  this.pcNewlist.length +
                  " exhibitor be selected, please select less then 20 exhibitors";
                // "当前展商数量为" +
                // this.pcNewlist.length +
                // "条," +
                // "最多只能筛选20条";
              }
              this.$message(msgtext);
              return;
            } else if (this.pcNewlist.length == 0) {
              if (this.langSet == "zh") {
                msgtext =
                  "当前展商数量为" +
                  this.pcNewlist.length +
                  "条," +
                  "最少需要筛选1条";
              } else {
                msgtext =
                  this.pcNewlist.length +
                  " exhibitor be selected, please select 1 exhibitor at least";
                // "当前展商数量为" +
                // this.pcNewlist.length +
                // "条," +
                // "最少需要筛选1条";
              }
              this.$message(msgtext);
              return;
            }
            var that = this;
            var label = [];
            if (that.productClass_2Name) {
              that.productClass_2Name.map((item) => {
                label.push(item);
              });
            }
            if (that.country) {
              label.push(that.country);
            }
            var markVal = this.langSet == 'zh'?'0':'1'
            let data = this.$qs.stringify({
              name: userInfo.nickname,
              duty: userInfo.dutiesName,
              company: userInfo.companyName,
              tel: userInfo.mobile,
              email: userInfo.email,
              label: label,
              demandtit: textarea,
              companylist: SubpcNewlist,
              mark: markVal,
              country: userInfo.country,
              city: userInfo.city,
              avatar: "https://oss.indata3.com/itsh/images/20210301/logo.jpg",
            });
            // let data = {
            //   name: userInfo.nickname,
            //   duty: userInfo.dutiesName,
            //   company: userInfo.companyName,
            //   tel: userInfo.mobile,
            //   email: userInfo.email,
            //   label: label,
            //   demandtit: textarea,
            //   companylist: this.pcNewlist,
            //   mark: 1,
            //   avatar: "https://oss.indata3.com/itsh/images/20210301/logo.jpg",
            // };
          
            sendEmial(data).then((res) => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$message("提交成功！");
                this.$router.push({ path: "/success" });
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    collectBtn(id, state, index) {
      if (!this.$store.state.isLogin) {
        this.$router.push({ path: "/login" });
        return false;
      }
      let data = this.$qs.stringify({
        memberid: this.memberid,
        type: 2,
        dataid: id,
        status: state,
      });
      getCollect(data)
        .then((res) => {
          if (res.data.errno == 0) {
            let data = this.$qs.stringify({
              keywords: this.keywords,
              showareaid: this.showareaid,
              memberid: this.memberid,
              productClass_1: this.productClass_1,
              productClass_2: this.productClass_2,
              country: this.country,
              pagesize: this.pagesize,
              page: this.page,
            });
            // this.getList(data);
            var newList = this.companyList;
            newList[index].isCollect = state;
            this.companyList = newList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    more() {
      var page = ++this.page;
      console.log(page);
      // productClass_1: this.productClass_1,
      // productClass_2: this.productClass_2,
      let data = this.$qs.stringify({
        keywords: this.keywords,
        showareaid: this.showareaid,
        memberid: this.memberid,
        productClass_1: ["4256", "4291"],
        productClass_2: ["4257", "4258", "4292"],
        country: this.country,
        pagesize: this.pagesize,
        page: page,
      });
      this.getList(data);
    },
    delBtn(id, index) {
      var companyList = this.companyList;
      var list = [];
      companyList.map((item) => {
        if (item.id !== id) {
          list.push(item);
        }
      });
      this.companyList = list;
    },
    getList(data) {
      getNewCompanyList(data)
        .then((res) => {
          console.log(res.data);
          if (res.data.errno == 0) {
            if (this.page == 1) {
              this.companyList = res.data.rst;
              console.log(this.companyList);
              this.total = Number(res.data.errmsg);
            } else {
              this.companyList = this.companyList.concat(res.data.rst);
            }
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    lableGetList(data, lable, lable1, lable2, name,enName) {
      console.log(lable, lable1, lable2);
      if (!(lable.length > 0) && !lable1.length > 0 && !lable2) {
        this.companyList = [];
        return;
      }
      this.productClass_1 = lable;
      this.productClass_2 = lable1;
      this.productClass_2Name = name;
      this.productClass_2EnName = enName;
      this.country = lable2;
      this.page = 1;
      this.getList(data);
    },
    toDetail(id) {
      //console.log(id)
      // this.$router.push({
      //   name: "exhibitorDetail",
      //   query: { id },
      // });
      const { href } = this.$router.resolve({
        path: "/exhibitorDetail",
        query: { id: id },
      });
      window.open(href, "_blank");
    },
  },
};
</script>
<style lang="scss">
  .isad{
    background: #9B8B1C;
  }
  .ad{
    position: absolute;
    color:#000000;
    font-size: 13px;
    right: 5px;
    bottom: 5px;
  } 
  .mesgStyle{
    background: #000000a1 !important;
    .el-message__content{
      color: #ffffff !important;
    }
  }
  @media only screen and (max-width: 767px) {
    .mesgStyle{
      top: 7rem !important;
    }
  }
</style>
<style lang="scss" scoped>
.duihao-icon {
  width: 24px;
  height: 24px;
}
.zhezhao {
  width: 100%;
  height: 100%;
  background: #2b26267c;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 2008;
}
.Listdialog {
  overflow: auto;
  width: 50%;
  height: 80%;
  background: #ffffff;
  border-radius: 4px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  padding: 30px;
  box-sizing: border-box;
  .companyWrap > div .middle .title {
    font-size: 14px !important;
  }
  .companyWrap > div .middle .fonts {
    font-size: 14px !important;
  }
}

.gouwuche {
  width: 80px;
  height: 80px;
  background: #CAC28A;
  position: fixed;
  bottom: 100px;
  right: 100px;
  border-radius: 50%;
  text-align: center;
  color: #ffffff;
  font-size: 24px;
  z-index: 2009;
  padding: 10px;
  box-sizing: border-box;
}
.gouwuche img {
  width: 100%;
  height: 100%;
}
.gouwuche_num {
  padding: 2px;
  width: 30px;
  height: 30px;
  font-size: 22px;
  line-height: 30px;
  position: absolute;
  top: -5px;
  right: -5px;
  color: #ffffff;
  background: rgb(238, 32, 32);
  border-radius: 50%;
}
.el-button--primary {
  background: linear-gradient(
    180deg,
    #ccd280 0%,
    #c4ca78 29%,
    #b8be6b 69%,
    #a1a751 100%
  );
  border-color: #CAC28A;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: linear-gradient(
    180deg,
    #ccd280 0%,
    #c4ca78 29%,
    #b8be6b 69%,
    #a1a751 100%
  );
  border-color: #CAC28A;
  color: #fff;
}
.active {
  background: #bbc080;
  color: #fff;
}
.companyWrap > div .middle .title {
  font-size: 18px !important;
  color: #000;
  font-weight: 600;
  line-height: 20px !important;
}
.lookmore {
  width: 153px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #666666;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin: 30px auto;
}
.conList {
  width: 100%;
  // height: 32px;
  background: #f8f8f8;
  // line-height: 32px;
  padding: 9px 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  margin: 0 auto 13px;
}
.conList p {
  padding-left: 20px;
}
.companyWrap {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-between;
}
.companyWrap > div {
  position: relative;
  border-radius: 9px;
  border: 2px solid #979797;
  padding: 11px 33px 11px 11px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  cursor: pointer;
  width: 45%;

  .logo {
    width: 80px;
    height: 80px;
    border-radius: 2px;
    border: 1px solid #ccc;
  }
  .middle {
    flex: 1;
    padding-left: 27px;
    color: rgba(0, 0, 0, 0.5);
    font-size: 20px;
    line-height: 20px;
    display: flex;
    flex-wrap: wrap;
    p {
      width: 100%;
    }
    .sub {
      align-self: flex-end;
    }
    .title {
      font-size: 22px;
      color: #000;
      font-weight: 600;
      line-height: 32px;
    }
  }
  .del-right {
    display: flex;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    top: 0;
    right: 11px;
    margin: auto;
    align-items: center;
    .del-icon {
      width: 24px;
      height: 22px;
    }
  }
  .right {
    display: flex;
    padding-top: 35px;
    box-sizing: border-box;
    position: absolute;

    bottom: 3px;
    right: 11px;
    .collect-icon {
      width: 24px;
      height: 22px;
      margin-right: 27px;
    }

    .carrow-right {
      font-size: 36px;
      font-weight: bold;
      line-height: 30px;
      margin-bottom: 20px;
    }
    .eye-icon {
      color: #7f7f7f;
      font-size: 14px;
      img {
        width: 12px;
        height: 8px;
        margin-right: 6px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .companyWrap > div .middle .title {
    font-size: 0.28rem !important;
  }
  .fonts {
    font-size: 0.2rem;
  }
  .Listdialog {
    width: 95%;
    border-radius: 0.3rem;
    padding: 0.1rem;
  }
  .gouwuche {
    width: 1rem;
    height: 1rem;
    right: 0.5rem;
    bottom: 0.5rem;
    font-size: 0.4rem;
  }
  .gouwuche_num {
    width: 0.4rem;
    height: 0.4rem;
    font-size: 0.2rem;
    line-height: 0.4rem;
  }
  .el-message-box {
    display: inline-block;
    width: auto;
    padding-bottom: 10px;
    vertical-align: middle;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    font-size: 18px;

    text-align: left;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .companyWrap > div {
    position: relative;
    border-radius: 9px;
    border: 2px solid #979797;
    padding: 11px 33px 11px 11px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    cursor: pointer;
    width: 100%;
  }
  .companyWrap {
    margin-top: 0.36rem;
  }
  // 分页
  .companywrap .el-pagination {
    padding: 0.05rem;
    height: 0.5rem;
  }
  .companywrap .el-pagination button,
  .companywrap .el-pagination span:not([class*="suffix"]),
  .companywrap .el-pager li {
    font-size: 12px;
  }
  .companywrap .el-pagination button,
  .companywrap .el-pagination span:not([class*="suffix"]) {
    height: 0.36rem;
    line-height: 0.4rem;
  }
  .companywrap .el-pagination.is-background .el-pager li {
    width: 0.4rem;
    height: 0.4rem;
    line-height: 0.4rem;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: 0;
    margin: 0 0.03rem;
  }
  .companywrap .el-pagination .btn-next .el-icon,
  .companywrap .el-pagination .btn-prev .el-icon {
    font-size: 12px;
    line-height: 0.4rem;
  }
  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    margin-right: 0;
  }
  // 分页
  .compangList {
    padding: 10px 15px;
    background: #fff;
    border: 0 none;
    box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    .logo {
      width: 0.98rem;
      height: 0.98rem;
      border: 0 none;
    }
    .middle {
      padding-left: 0.2rem;
      p {
        font-size: 0.12px;
      }
      .title {
        font-size: 14px;
        line-height: 18px;
      }
    }
    .right {
      padding-top: 0px;
      align-items: center;
      // display: none;
    }
    .active {
      border: 1px solid yellow;
    }
  }
}
</style>
<style>
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #bbc080 !important;
  border-color: #bbc080 !important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #bbc080;
}
.el-checkbox__inner:hover {
  border-color: #bbc080;
}
.el-checkbox__inner {
  width: 20px;
  height: 20px;
}
.el-checkbox__inner::after {
  width: 5px;
  height: 10px;
  left: 6px;
}
</style>